export default function(variableName, storeModuleName) {
  let mixin = { props: {}, computed: {} }
  mixin.props.isLoading = { type: Boolean, default: false }
  mixin.computed[`_${variableName}`] = function() {
    let store = storeModuleName
      ? this.$store[storeModuleName]['state'][variableName]
      : this.$store
      ? this.$store.state[variableName]
      : this.isLoading
    return store
  }
  return mixin
}
